import { changeSkin } from '@/utils/common.js';

export default {
  components: {
  },
  data() {
    return {
      list: []
      // {title: '吉林三部门联合部署疫情防控期间农村产权交易工作'}, {title: '吉林三部门联合部署疫情防控期间农村产权交易工作'}
    };
  },
  created() {
  },
  computed: {
  },
  methods: {
    changeSkin,
    download () {}
  }
};
